import { TemplateType } from "./template.type";
import { BriefTemplateLabel } from "./brief-template-label.interface";
import { CampaignBriefTemplateLabels } from "./campaign-brief/campaign-brief-template-labels.constant";
import { ExecutionBriefTemplateLabels } from "./execution-brief/execution-brief-template-labels.constant";
import { Nullable } from "../common";

export function getLabelForTemplateType(resourcetype: TemplateType): Nullable<string> {
  return getTemplates().find((template) => template.value === resourcetype)?.label || null;
}

function getTemplates(): BriefTemplateLabel[] {
  return [...CampaignBriefTemplateLabels, ...ExecutionBriefTemplateLabels];
}
